module.exports = __webpack_public_path__ + "img/600.fb53011b.svg";